import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from '../../services/i18nService';

import styles from './testOverview.scss';
import parentTestService from '../../services/ParentTestService';
import QTIAssessmentItem from '../question/QTIAssessmentItem';
import sessionReader from '../../store/readHelpers/SessionReader';
import apiService from '../../services/api/ApiService';
import candidateProgressConstants from '../../constants/CandidateProgressConstants';
import DescriptionConfirmation from './DescriptionConfirmation';
import descriptionDocumentSelector from '../../selectors/testOverview/DescriptionDocumentSelector';
import testComponentService from '../../services/TestComponentService';

const DescriptionDocument = (props) => {
    const {
        descriptionDocumentApproved,
        disableApproveButton,
        documentModel,
        initialShowDescriptionDocument,
        lockDescriptionToggleButton,
        requiresDescriptionDocumentApproval,
        services,
        showApproveButton,
        test,
    } = props;

    const assessmentRunId = test.assessmentRunId;

    const descriptionDocumentStyle = showApproveButton ? styles.current : '';

    const [showDescriptionDocument, setShowDescriptionDocument] = useState(initialShowDescriptionDocument);
    const icon = showDescriptionDocument ? 'up' : 'down';
    const showQtiAssessmentItem = !!showDescriptionDocument && (documentModel !== undefined);

    useEffect(() => {
        if (descriptionDocumentApproved) {
            apiService.notifyClientEvent(candidateProgressConstants.READY, '', true, assessmentRunId);
        }
    }, [descriptionDocumentApproved]);

    const fakeCall = () => {};

    const confirmDescriptionDocument = () => {
        setShowDescriptionDocument(false);
        parentTestService.setChildTestDescriptionDocumentApproved(assessmentRunId);
    };

    const toggleDescriptionDocument = () => {
        setShowDescriptionDocument(!showDescriptionDocument);
    };

    const updateCompletelyPlayedMediaCounter = () => {
        testComponentService.updateHasCompletelyPlayedMedia(test);
    };

    const renderConfirmationText = () => {
        if (requiresDescriptionDocumentApproval) {
            if (descriptionDocumentApproved) {
                return <span className="completed">&nbsp;{t('childTest.confirmed')}</span>;
            }
            return <span className="incomplete">&nbsp;{t('childTest.notConfirmed')}</span>;
        }
        return null;
    };

    return (
        <div className={`${styles.actionBox} ${descriptionDocumentStyle}`}>
            <div className={styles.descriptionDocumentHeader}>
                <button
                    className={styles.toggle}
                    onClick={toggleDescriptionDocument}
                    aria-expanded={showDescriptionDocument}
                    aria-controls={`${assessmentRunId}_descDoc`}
                    disabled={lockDescriptionToggleButton}
                >
                    <i className={`fa fa-chevron-${icon}`} aria-hidden />
                    <span className={styles.toggleLabel}>{t('childTest.testInformation')}</span>
                </button>

                { renderConfirmationText() }
            </div>

            { showQtiAssessmentItem && <div className={styles.descriptionDocumentBody} id={`${assessmentRunId}_descDoc`}>
                <QTIAssessmentItem
                    callback={fakeCall}
                    choiceSequences={{}}
                    context={sessionReader.getContext()}
                    key={`${assessmentRunId}_childDescDoc`}
                    reportReady={fakeCall}
                    question={documentModel}
                    services={services}
                    userResponses={{}}
                    settingValues={{}}
                    viewMedia="screen"
                    onMediaPlayedToCompletion={updateCompletelyPlayedMediaCounter}
                    onMediaPlayedCounterReset={updateCompletelyPlayedMediaCounter}
                />
            </div>
            }

            { showApproveButton && <DescriptionConfirmation
                disabled={disableApproveButton}
                onDescriptionConfirmed={confirmDescriptionDocument}
            /> }
        </div>
    );
};

DescriptionDocument.propTypes = {
    descriptionDocumentApproved: PropTypes.bool.isRequired,
    disableApproveButton: PropTypes.bool.isRequired,
    documentModel: PropTypes.object,
    initialShowDescriptionDocument: PropTypes.bool.isRequired,
    lockDescriptionToggleButton: PropTypes.bool.isRequired,
    requiresDescriptionDocumentApproval: PropTypes.bool.isRequired,
    services: PropTypes.object,
    showApproveButton: PropTypes.bool.isRequired,
    test: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => descriptionDocumentSelector.selectProps(state, ownProps);

export default connect(mapStateToProps)(DescriptionDocument);
